import { render, staticRenderFns } from "./addDataPrivilegeStaff.vue?vue&type=template&id=1172f75d&scoped=true"
import script from "./addDataPrivilegeStaff.vue?vue&type=script&lang=js"
export * from "./addDataPrivilegeStaff.vue?vue&type=script&lang=js"
import style0 from "./addDataPrivilegeStaff.vue?vue&type=style&index=0&id=1172f75d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1172f75d",
  null
  
)

export default component.exports